import React, { useState, useEffect } from "react";
import { Modal } from "@mui/material";
import styles from "./index.module.scss";
import { Button } from "../../common/components/Button";
import { Button as MUI } from "../../components/components/ui/button";
import GrayLine from "../../common/components/GrayLine";
import downloadingReport from "../../assets/images/InfographicDownload.svg";
import { BUTTONLABELS, REPORTS } from "../../constants/textConstants";
interface DownloadPopupProps {
  open: boolean;
  onClose: () => void;
  selected: string | null;
  setSelected: (value: string) => void;
  onDownload: (reportName: string) => void;
}

const DownloadPopup: React.FC<DownloadPopupProps> = ({
  open,
  onClose,
  selected,
  setSelected,
  onDownload,
}) => {
  const [baseName, setBaseName] = useState("");

  useEffect(() => {
    if (selected) {
      const cleanName = selected
        .replace(/\s+/g, "")
        .replace(/[^a-zA-Z0-9]/g, "");
      setBaseName(cleanName);
    }
  }, [selected]);

  const handleSave = () => {
    const fileName = `${baseName}.xlsx`;
    onDownload(fileName);
  };

  return (
    <Modal open={open} onClose={onClose}>
      <div className={styles.popupContainer}>
        <div className={styles.header}>
          <span className={styles.title}>
            <img src={downloadingReport} alt="downloading" />
            {REPORTS.DOWNLOAD_REPORT}
          </span>
        </div>

        <div className={styles.divider}>
          <GrayLine />
        </div>

        {/* Input with fixed extension */}
        <div className={styles.optionsContainer}>
          <label className={styles.optionText} style={{ marginBottom: 8 }}>
            {REPORTS.REPORTNAME}
          </label>
          <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
            <input
              type="text"
              value={baseName}
              onChange={(e) =>
                setBaseName(e.target.value.replace(/\.xlsx$/i, ""))
              }
              style={{
                width: "100%",
                padding: "8px 12px",
                fontSize: 16,
                border: "1px solid #ccc",
                borderRadius: "4px 0 0 4px",
                marginBottom: 24,
                borderRight: "none",
              }}
            />
            <span
              style={{
                padding: "8px 12px",
                fontSize: 16,
                border: "1px solid #ccc",
                borderRadius: "0 4px 4px 0",
                backgroundColor: "#f9f9f9",
                marginBottom: 24,
                borderLeft: "none",
                color: "#555",
                whiteSpace: "nowrap",
              }}
            >
              .xlsx
            </span>
          </div>
        </div>

        <div className={styles.footer}>
          <MUI variant="outlined" className={styles.cancel} onClick={onClose}>
            {BUTTONLABELS.CANCEL}
          </MUI>
          <Button
            onClick={handleSave}
            buttonClassName={styles.downloadBtn}
            disable={!baseName.trim()}
          >
            {BUTTONLABELS.DOWNLOAD}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DownloadPopup;
